import Calc from '../modules/calc';

class Cable extends Calc {
    constructor() {
        super();
        // Calbe images
        this.images = document.querySelectorAll('.custom-cable__images');
        this.placeholder = document.getElementById('custom-cable__placeholder');
        this.mainWireBlack = document.getElementById('black-main-wire');
        this.mainWireRed = document.getElementById('red-main-wire');
        this.auxWireBlack = document.getElementById('black-aux-wire');
        this.auxWireRed = document.getElementById('red-aux-wire');

        this.topConnectionImages = document.querySelectorAll('.top-connection-images');
        this.bottomConnectionImages = document.querySelectorAll('.bottom-connection-images');
        this.bottomAuxConnectionImages = document.querySelectorAll('.bottom-aux-connection-images');

        this.eventsCable();

    }

    eventsCable() {

        this.wire_type.onchange = () => {

            super.calculate();

            // Cable image change
            if (this.wire_type.value == -1 ) {
                this.placeholder.style.display = "block";
                this.hideAllimages();
                this.btn.classList.toggle("add-to-cart-active");
            } else {
                this.placeholder.style.display = "none";
                this.changeMainWire();
                this.changeAuxWire();
                this.changeTopConnection();
                this.changeBottomConnection();
                this.changeBottomAuxConnection();
                this.btn.classList.toggle("add-to-cart-active");

            }
        }

        this.wire_color.forEach(e => {
            e.onchange = (e) =>  {
                super.calculate();
                this.changeMainWire();
                this.changeAuxWire();
            }
            
        });

        this.top_connection.onchange = (e) => {
            super.calculate();
            this.changeTopConnection();
        }

        this.bottom_connection.onchange = (e) => {
            super.calculate();
            this.changeBottomConnection();
        }


        this.aux_wire_type.onchange = () => {
            super.calculate();
            this.changeAuxWire();
            this.changeBottomAuxConnection();

            // Cable image change
            if (this.aux_wire_type.value == -1 ) {
                this.auxWireBlack.style.display = "none";
                this.auxWireRed.style.display = "none";
            } 
            
        }

        this.aux_lug.onchange = (e) => {
            super.calculate();
            this.changeBottomAuxConnection();
        }

        this.reset.onclick = (e) => {
            this.form.reset();
            super.calculate();
            this.placeholder.style.display = "block";
            this.hideAllimages();
            this.btn.classList.toggle("add-to-cart-active");
        }

    }

    hideAllimages() {
        this.images.forEach(e => {
            e.style.display = "none";
        });
    }


    changeMainWire() {
            //Main wire change
    if(this.wire_color[0].checked && this.wire_type.value != -1 ) {
        this.mainWireBlack.style.display = "block";
        this.mainWireRed.style.display = "none";
        }
    if(this.wire_color[1].checked && this.wire_type.value != -1 ) {
        this.mainWireRed.style.display = "block";
        this.mainWireBlack.style.display = "none";
        }
    }

    changeAuxWire() {
    //Aux wire change
    if(this.wire_color[0].checked && this.wire_type.value != -1 && this.aux_wire_type.value != -1 ) {
        this.auxWireBlack.style.display = "block";
        this.auxWireRed.style.display = "none";
        }
    if(this.wire_color[1].checked && this.wire_type.value != -1 && this.aux_wire_type.value != -1 ) {
        this.auxWireRed.style.display = "block";
        this.auxWireBlack.style.display = "none";
        }

    }

    //Top connection

    hideAllTopConnections() {
    this.topConnectionImages.forEach(e => {
        e.style.display = "none";
    })
    }

    showTopConnection(num) {
        document.querySelector(`.top-connection-${num}`).style.display = "block";
    }

    changeTopConnection() {
    if (this.top_connection.value == -1) {
        this.hideAllTopConnections();
        return;
    }

    else if (this.wire_type.value != -1) { 
        this.hideAllTopConnections();
        this.showTopConnection(this.top_connection.value);
    }
    }

    //Bottom connection

    hideAllBottomConnections() {
    this.bottomConnectionImages.forEach(e => {
        e.style.display = "none";
    })
    }

    showBottomConnection(num) {
        document.querySelector(`.bottom-connection-${num}`).style.display = "block";
    }

    changeBottomConnection() {
    if (this.bottom_connection.value == -1) {
        this.hideAllBottomConnections();
        return;
    }

    else if (this.wire_type.value != -1) { 
        this.hideAllBottomConnections();
        this.showBottomConnection(this.bottom_connection.value);
    }
    }

    //Bottom aux connection

        hideAllAuxBottomConnections() {
        this.bottomAuxConnectionImages.forEach(e => {
            e.style.display = "none";
        })
        }
    
        showBottomAuxConnection(num) {
            document.querySelector(`.bottom-aux-connection-${num}`).style.display = "block";
        }
    
        changeBottomAuxConnection() {
        if (this.aux_lug.value == -1 || this.aux_wire_type.value == -1) {
            this.hideAllAuxBottomConnections();
            return;
        }
    
        else if (this.wire_type.value != -1) { 
            this.hideAllAuxBottomConnections();
            this.showBottomAuxConnection(this.aux_lug.value);
        }
        }



}

export default Cable;